import script from "./sendNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./sendNotice.vue?vue&type=script&lang=ts&setup=true"

import "./sendNotice.vue?vue&type=style&index=0&id=64966ccf&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64966ccf"]])

export default __exports__